import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const updateFhirJson = async (foi = null, resourceJson = null, title = null, apiToken = null, connectionId = null,
    pubStatus = "active", aboutformstateid = null, tool = null, parentFollowup = false) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!foi || !resourceJson || !title) {
        console.log("missing foi, resourceJson, or title");
        return null;
    }
    console.log("CALLING SERVER with updatefhirresource");

    let updateData = {
        "functionid": "updatefhirresource",
        "fhirEntry": JSON.stringify(resourceJson, null, 2),
        "apiToken": apiToken,
        "resourcetype": resourceJson.resourceType,
        "resourceid": foi,
        "title": title,
        "status": pubStatus,
        "bypasswarnings": false,
        'aboutformstateid': aboutformstateid,
        'tool': tool,
        'parentFollowup': parentFollowup,
        'connectionId': connectionId
    };

    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: updateData,
    }).then(async (resp) => {
        if (resp?.data) {
            if (resp.data.success === true) {
                return resp.data;
            }
            if (resp.data.warningMessage && window.confirm(resp.data.warningMessage)) {
                updateData["bypasswarnings"] = true;
                return await axios({
                    method: 'POST',
                    url: fevir_node_server_address,
                    timeout: 120000,
                    data: updateData,
                }).then((resp) => {
                    if (resp?.data) {
                        return resp.data;
                    }
                    console.log("NO RESPONSE from updatefhirresource call");
                }).catch((error) => { console.log(error); });
            }
            return resp.data;
        }
        console.log("NO RESPONSE from updatefhirresource call");
    }).catch((error) => { console.log(error); });
};

export default updateFhirJson;